import { useEffect, useState } from "react";
import useSound from "use-sound";
//IMPORT AUDIO FILES
import goForwardSFX from "../../../assets/audio/globals/goForwardSFX.mp3";
// import divideSFX from "../../../assets/audio/globals/divideSFX.mp3";
// import multiplySFX from "../../../assets/audio/globals/multiplySFX.mp3";
import playSFX from "../../../assets/audio/globals/playSFX.mp3";
import cashoutSFX from "../../../assets/audio/globals/cashoutSFX.mp3";
import confirmSFX from "../../../assets/audio/globals/confirmSFX.mp3";
import goBackSFX from "../../../assets/audio/globals/goBackSFX.mp3";
import switchSFX from "../../../assets/audio/globals/switchSFX.mp3";
import tabChangeSFX from "../../../assets/audio/globals/tabChangeSFX.mp3";
// import notificationSFX from "../../../assets/audio/globals/notificationSFX.mp3";
// import errorSFX from "../../../assets/audio/globals/errorSFX.mp3";
import setSeedSFX from "../../../assets/audio/globals/setSeedSFX.mp3";
// import backgroundSFX from "../../../assets/audio/globals/backgroundSFX.mp3";
//
import randomBtnSFX from "../../../assets/audio/mines/randomBtnSFX.mp3";

export default function useGlobalAudio(volume, sound, music, localVolume) {
  // set sound is on/off depending on userSettings sound value: "0" off, "1" is on
  const [soundIsOn, setSoundIsOn] = useState(false);

  useEffect(() => {
    sound === "1" ? setSoundIsOn(true) : setSoundIsOn(false);
  }, [sound]);

  // go to page, go back or close, confirm
  const [playGoForwardSFX] = useSound(goForwardSFX, {
    volume: volume,
  });
  const [playGoBackSFX] = useSound(goBackSFX, {
    volume: volume,
  });
  const [playConfirmSFX] = useSound(confirmSFX, {
    volume: volume,
  });
  const [playSetSeedSFX] = useSound(setSeedSFX, {
    volume: volume,
  });

  // multiply, divide, pluss, minus, longPress plus, longPress minus
  // const [playMultiplySFX] = useSound(multiplySFX, {
  //   volume: volume,
  // });
  // const [playDivideSFX] = useSound(divideSFX, { volume: volume });

  // game play
  const [playPlaySFX] = useSound(playSFX, {
    volume: volume,
  });
  const [playCashoutSFX] = useSound(cashoutSFX, {
    volume: volume,
  });

  // tabs, switch, select
  const [playSwitchSFX] = useSound(switchSFX, {
    volume: volume,
  });
  const [playTabChangeSFX] = useSound(tabChangeSFX, {
    volume: volume,
  });

  // custom sounds
  const [playRandomSFX] = useSound(randomBtnSFX, {
    volume: volume,
  });
  // notifications, errors
  // const [playNotificationSFX] = useSound(notificationSFX, {
  //   volume: volume,
  // });
  // const [playErrorSFX] = useSound(errorSFX, {
  //   volume: volume,
  // });

  // /* <<<<<< background music >>>>>> */

  // // set music is on/off for looping background music
  // const [musicIsOn, setMusicIsOn] = useState(false);

  // const [play, { stop }] = useSound(backgroundSFX, {
  //   volume: localVolume,
  //   onend: () => setMusicIsOn(true),
  // });

  // // stop music before initialize, if error occures or if music is off
  // useEffect(() => {
  //   if (music === "1" || musicIsOn) {
  //     stop();
  //     play();
  //     setMusicIsOn(false);
  //   } else {
  //     stop();
  //   }
  //   return function cleanup() {
  //     stop();
  //   };
  // }, [play, stop, music, musicIsOn]);
  
  const AUDIO = {
    goForward: () => soundIsOn && playGoForwardSFX(),
    goBack: () => soundIsOn && playGoBackSFX(),
    tabChange: () => soundIsOn && playTabChangeSFX(),
    play: () => soundIsOn && playPlaySFX(),
    cashout: () => soundIsOn && playCashoutSFX(),
    switch: () => soundIsOn && playSwitchSFX(),
    setSeed: () => soundIsOn && playSetSeedSFX(),
    confirm: () => soundIsOn && playConfirmSFX(),
    pickRandom: () => soundIsOn && playRandomSFX(),
  };
  return { AUDIO };
}
